/**
 * Thin entry point — no jQuery dependency.
 *
 * Assembles lMain from shared @lib modules and exposes it as window.lMain.
 * Used on lightweight pages (e.g. redirects, minimal forms) that do not load
 * jQuery. Replaces code/public/js/core/thin-1.js.
 */

import { getCoreVar, getDataVar } from '@lib/data';
import { ajax } from '@lib/ajax';
import { storeGet, storeHas, storeRemove, storeSet } from '@lib/store';

// ---------------------------------------------------------------------------
// lMain
// ---------------------------------------------------------------------------

const lMain = {
    getCoreVar,
    getDataVar,

    getUtmData(): string {
        return JSON.stringify({ cur: storeGet('rxc'), int: storeGet('rxi') });
    },

    storeGet,
    storeHas,
    storeRemove,
    storeSet,
    ajax,
};

window.lMain = lMain;

// ---------------------------------------------------------------------------
// Page load: UTM storage and Matomo visitor ID
// ---------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.search) {
        const query = new URLSearchParams(window.location.search);
        const utmParams = ['campaign', 'source', 'medium', 'content', 'term', 'id'] as const;
        const obj: Record<string, string | number> = {};

        for (const param of utmParams) {
            const value = query.get(`utm_${param}`);
            if (value) {
                // Strip duplicated query strings embedded in the value (redirect edge case).
                obj[param] = value.split('?')[0];
            }
        }

        if (Object.keys(obj).length > 0) {
            obj._time = Math.floor(Date.now() / 1000);
            storeSet('rxc', obj, true);
            if (!storeHas('rxi')) {
                storeSet('rxi', obj);
            }
        }
    }

});
